export const StepOtp = (
  e: React.KeyboardEvent<HTMLInputElement>,
  index: number,
  elm: string
) => {
  const target = e.target as HTMLInputElement;
  const value = target.value;

  if (e.key !== 'Backspace') {
    if (value.length === target.maxLength && index < 4) {
      document.getElementById(`${elm}${index + 1}`)?.focus();
    }
  } else {
    if (value.length === 0 && index > 0) {
      document.getElementById(`${elm}${index - 1}`)?.focus();
    }
  }

  const items = document.getElementsByClassName('step-input');
  for (let i = 0; i < items.length; i++) {
    (items[i] as HTMLInputElement).disabled = false;
  }
};
